import React from 'react';
import { connect } from "react-redux";
import updateUser from '../../../../API/Provider/PutUser'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import Loader from '../../../../Global/loader'
import { withNamespaces } from 'react-i18next';
import OIBchecker from '../../../../Global/OIBchecker';
import { Form, Row, Col, Button } from 'react-bootstrap'
import history from '../../../../history';

class UpdatePorezi extends React.Component {
    constructor(props) {
        super(props); 
        this.submitUpdate = this.submitUpdate.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
    }

    state={
        loading: false,
        password: ""
    }

    componentDidMount = async () => {
        document.title = this.props.t("User") + "-" + this.props.t("Update")         
         
         await this.setState({
             loading: false            
         })
    }
    
    handleChange = async (e) => {
        if (e.target.id === "oib") {
            if(e.target.value.length < 12){
                await this.props.mapState("CHANGE_PROVIDER_ONE_USER_DETAILS", e.target) 
            }
        }       
        else{
            await this.props.mapState("CHANGE_PROVIDER_ONE_USER_DETAILS", e.target) 
        }
    }

    handleChangePassword(value){
        this.setState({
            password: value
        })
    }

    submitUpdate = async (e) => {        
        this.setState({ loading: true })
        e.preventDefault()

        if(OIBchecker(this.props.oneUser.oib)){
            let createPP = await updateUser(
                this.props.oneUser,
                this.props.oneProvider.uuid,
                this.state.password
            )

            if(createPP.data.status === 200){ 
                store.addNotification({
                    title: this.props.t('Success!'),
                    message: this.props.t("Update was successful"),
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                    duration: 5000,
                    pauseOnHover: true
                    }
                });

                this.setState({ loading: false })
                this.props.goBack()
            }
            else{
                store.addNotification({
                    title: this.props.t('Error!'),
                    message: this.props.t(createPP.data.data.message),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animate__animated", "animate__fadeIn"],
                    animationOut: ["animate__animated", "animate__fadeOut"],
                    dismiss: {
                    duration: 5000,
                    onScreen: true
                    }
                })

                this.setState({ loading: false })
            }
        }
        else{
            store.addNotification({
                title: this.props.t('Error!'),
                message: this.props.t('Invalid OIB'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            })

            this.setState({ loading: false })
        } 
    }

    handleCountryChange(e){  
        this.setState({
            country: e
        })                  
    }
   
    render(){  
        const { t } = this.props
        
        return (
            <div>
                {this.state.loading ?
                    <Loader />
                :
                <Form className="form-container">
                    <Row>        
                        <Col sm={12} lg={6} xl={4}>                            
                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="Form.Label" column sm={2} md={4}>{t('Username')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                            id="username"                          
                                            type="text"
                                            value={this.props.oneUser.username}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="oib" column sm={2} md={4}>{t('OIB')}</Form.Label>
                                <Col sm={10} md={8}>
                                   <Form.Control        
                                            id="oib"                          
                                            type="text"
                                            value={this.props.oneUser.oib}
                                            onChange={e => this.handleChange(e)}
                                        />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="password" column sm={2} md={4}>{t('Password')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <input
                                        id="password"
                                        type="text"
                                        value={this.props.oneUser.password}
                                        onChange={e => this.handleChangePassword(e.target.value)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="email" column sm={2} md={4}>{t('Email')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <input
                                        id="email"
                                        type="text"
                                        value={this.props.oneUser.email}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="first_name" column sm={2} md={4}>{t('First name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <input
                                        id="first_name"
                                        type="text"
                                        value={this.props.oneUser.first_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                           <Form.Group as={Row} className="mb-3">
                                <Form.Label htmlFor="last_name" column sm={2} md={4}>{t('Last name')}</Form.Label>
                                <Col sm={10} md={8}>
                                    <input
                                        id="last_name"
                                        type="text"
                                        value={this.props.oneUser.last_name}
                                        onChange={e => this.handleChange(e)}
                                    />
                                </Col>
                            </Form.Group>

                            <Col sm={4} className="float-right p-0">
                                <Button                                     
                                    className="btnSpremi"
                                    onClick={(e) => this.submitUpdate(e)}
                                >
                                    {t('Save')}
                                </Button>
                            </Col>                                  
                        </Col>
                    </Row>
                    
                    <div className="form-group mt-5">
                        <div
                            className="btn btn-default mb-2"
                            onClick={() => history.goBack()}                       
                        > 
                            <BsBackspaceFill size={30} />  
                            <strong> {t('Back')} </strong>
                        </div> 
                    </div>    
                </Form>
                }
            </div>

        )
    }
}
const mapStateToProps = state => {
    return {
        oneUser: state.provider.oneUser,
        oneProvider: state.provider.oneProvider,
        providerUserVisibleColumns: state.provider.providerUserVisibleColumns
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(UpdatePorezi));